import { AbstractControl, ValidatorFn } from '@angular/forms';

export function numberFormatValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }
    // check if value is a number
    if (!isNaN(control.value)) {
      return null;
    }
    const isValid = /^\d{1,3}((\.)?\d{3})*(,\d{1,2})?$/.test(
      control.value?.trim()
    );
    return isValid ? null : { invalidNumberFormat: { value: control.value } };
  };
}
